import {
  FETCH_COMPONENTS_REQUEST,
  FETCH_FILTERED_BATCH_LIST,
  FETCH_GENEALOGY_REPORT,
  FETCH_GENEALOGY_REPORT_BY_ID,
  FETCH_GENEALOGY_REPORT_LIST_REQUEST,
  FETCH_MANUFACTURING_SITES_REQUEST,
  FETCH_PARAMETERS_REQUEST,
  FETCH_PRODUCED_PRODUCTS_REQUEST,
  FETCH_PRODUCT_DESCRIPTION_REQUEST,
  FETCH_UNIT_OPERATIONS_REQUEST,
  REPORT_DATA,
  SAVE_REPORT_DATA,
} from "./types";
import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";
import genealogyService from "../../services/genealogyService";
// import * as types from "./types";

// const service = new GenealogyService();

export const fetchGenealogyReports = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_GENEALOGY_REPORT_LIST_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await genealogyService.fetchGenealogyReports(requestData);
    dispatch({
      type: FETCH_GENEALOGY_REPORT_LIST_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_GENEALOGY_REPORT_LIST_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchProducedProducts = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_PRODUCED_PRODUCTS_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await genealogyService.fetchProducedProducts(requestData);

    dispatch({
      type: FETCH_PRODUCED_PRODUCTS_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_PRODUCED_PRODUCTS_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchManufacturingSites = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_MANUFACTURING_SITES_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response =
      await genealogyService.fetchManufacturingSites(requestData);

    dispatch({
      type: FETCH_MANUFACTURING_SITES_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_MANUFACTURING_SITES_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchUnitOperations = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_UNIT_OPERATIONS_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await genealogyService.fetchUnitOperations(requestData);

    dispatch({
      type: FETCH_UNIT_OPERATIONS_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_UNIT_OPERATIONS_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchProductDescription = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_PRODUCT_DESCRIPTION_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response =
      await genealogyService.fetchProductDescription(requestData);

    dispatch({
      type: FETCH_PRODUCT_DESCRIPTION_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_PRODUCT_DESCRIPTION_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchParameters = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_PARAMETERS_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await genealogyService.fetchParameters(requestData);

    dispatch({
      type: FETCH_PARAMETERS_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_PARAMETERS_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const clearReportData = () => (dispatch) => {
  dispatch({
    type: REPORT_DATA,
    payload: { ...initialState?.apiStatus, loader: false, data: [] },
  });
};

export const generateGenealogyReport = (payload) => async (dispatch) => {
  dispatch({
    type: REPORT_DATA,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await genealogyService.generateGenealogyReport(payload);
    dispatch({
      type: REPORT_DATA,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data,
      },
    });

    return {
      success: true,
      data: response?.data,
    };
  } catch (error) {
    dispatch({
      type: REPORT_DATA,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
    return {
      success: false,
    };
  }
};

export const fetchComponents = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_COMPONENTS_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await genealogyService.fetchComponents(requestData);
    dispatch({
      type: FETCH_COMPONENTS_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data,
      },
    });
    // dispatch({
    //   type: FETCH_COMPONENTS_REQUEST,
    //   payload: {
    //     ...initialState?.apiStatus,
    //     loader: false,
    //     data: [
    //       {
    //         segment: "FT0158_3000007394_CBD Epidiolex",
    //         components: [
    //           {
    //             material_number: "PA0022",
    //             material_description: "105mL Amber Type 3 Glass Bottle PP28 JP",
    //           },
    //           {
    //             material_number: "PD0003",
    //             material_description: "28mm Child Resistant and Tamper Evident",
    //           },
    //           {
    //             material_number: "DK0006",
    //             material_description: "Anhydrous Ethanol EP & USP",
    //           },
    //           {
    //             material_number: "DJ0046",
    //             material_description: "Cannabidiol CBD API B750 SPSL",
    //           },
    //           {
    //             material_number: "CG0031",
    //             material_description: "CBD Extract from Pellets (M250) – B750",
    //           },
    //           {
    //             material_number: "CG0030",
    //             material_description:
    //               "Decarboxylated CBD BRM from Pellets M250",
    //           },
    //           {
    //             material_number: "CG0029",
    //             material_description: "Milled CBD BRM Pellets M250s Bldg 750",
    //           },
    //           {
    //             material_number: "BD0045",
    //             material_description: "Pelleted CBD BRM M250 GROWn at RG",
    //           },
    //           {
    //             material_number: "DJ0037",
    //             material_description:
    //               "Refined CBD Extract M250 Pellets  - B750",
    //           },
    //           {
    //             material_number: "DK0060",
    //             material_description: "Refined Sesame Oil PH Eur 200kg Drums",
    //           },
    //           {
    //             material_number: "DK0040",
    //             material_description: "Strawberry Flavour 501094 A Liquid",
    //           },
    //           {
    //             material_number: "DK0041",
    //             material_description: "Sucralose Ph Eur & USP/NF",
    //           },
    //         ],
    //       },
    //     ],
    //   },
    // });
  } catch (error) {
    dispatch({
      type: FETCH_COMPONENTS_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

// export const fetchGenealogySingleReport = (requestData) => async (dispatch) => {
//   dispatch({
//     type: FETCH_GENEALOGY_REPORT,
//     payload: { ...initialState?.apiStatus, loader: true },
//   });
//   try {
//     const response =
//       await genealogyService.fetchGenealogySingleReport(requestData);
//     dispatch({
//       type: FETCH_GENEALOGY_REPORT,
//       payload: {
//         ...initialState?.apiStatus,
//         loader: false,
//         data: response?.data?.data,
//       },
//     });
//   } catch (error) {
//     // dispatch({
//     //   type: FETCH_GENEALOGY_REPORT,
//     //   payload: {
//     //     ...initialState.apiStatus,
//     //     loader: false,
//     //     message: errorMessage(error),
//     //     apiError: true,
//     //   },
//     // });

//     dispatch({
//       type: FETCH_GENEALOGY_REPORT,
//       payload: {
//         ...initialState?.apiStatus,
//         loader: false,
//         data: {
//           report_data: [
//             {
//               id: 1,
//               material_number: "MAT-1001",
//               material_description: "Paracetamol API",
//               product_type: "API",
//               sap_production_date: "2025-01-01",
//               vendor_batch_number: "VB-001",
//               purchase_document: "PO-9001",
//               unit_operation: "Granulation",
//             },
//             {
//               id: 2,
//               material_number: "MAT-1002",
//               material_description: "Ibuprofen Powder",
//               product_type: "API",
//               sap_production_date: "2025-01-02",
//               vendor_batch_number: "VB-002",
//               purchase_document: "PO-9002",
//               unit_operation: "Blending",
//             },
//             {
//               id: 3,
//               material_number: "MAT-1003",
//               material_description: "Lactose Monohydrate",
//               product_type: "Excipient",
//               sap_production_date: "2025-01-03",
//               vendor_batch_number: "VB-003",
//               purchase_document: "PO-9003",
//               unit_operation: "Mixing",
//             },
//             {
//               id: 4,
//               material_number: "MAT-1004",
//               material_description: "Magnesium Stearate",
//               product_type: "Excipient",
//               sap_production_date: "2025-01-04",
//               vendor_batch_number: "VB-004",
//               purchase_document: "PO-9004",
//               unit_operation: "Lubrication",
//             },
//             {
//               id: 5,
//               material_number: "MAT-1005",
//               material_description: "Crospovidone",
//               product_type: "Excipient",
//               sap_production_date: "2025-01-05",
//               vendor_batch_number: "VB-005",
//               purchase_document: "PO-9005",
//               unit_operation: "Dry Mixing",
//             },
//             {
//               id: 6,
//               material_number: "MAT-1006",
//               material_description: "Amoxicillin Trihydrate",
//               product_type: "API",
//               sap_production_date: "2025-01-06",
//               vendor_batch_number: "VB-006",
//               purchase_document: "PO-9006",
//               unit_operation: "Granulation",
//             },
//             {
//               id: 7,
//               material_number: "MAT-1007",
//               material_description: "Microcrystalline Cellulose",
//               product_type: "Excipient",
//               sap_production_date: "2025-01-07",
//               vendor_batch_number: "VB-007",
//               purchase_document: "PO-9007",
//               unit_operation: "Blending",
//             },
//             {
//               id: 8,
//               material_number: "MAT-1008",
//               material_description: "Croscarmellose Sodium",
//               product_type: "Excipient",
//               sap_production_date: "2025-01-08",
//               vendor_batch_number: "VB-008",
//               purchase_document: "PO-9008",
//               unit_operation: "Mixing",
//             },
//             {
//               id: 9,
//               material_number: "MAT-1009",
//               material_description: "Azithromycin",
//               product_type: "API",
//               sap_production_date: "2025-01-09",
//               vendor_batch_number: "VB-009",
//               purchase_document: "PO-9009",
//               unit_operation: "Granulation",
//             },
//             {
//               id: 10,
//               material_number: "MAT-1010",
//               material_description: "Starch Paste",
//               product_type: "Binder",
//               sap_production_date: "2025-01-10",
//               vendor_batch_number: "VB-010",
//               purchase_document: "PO-9010",
//               unit_operation: "Binding",
//             },
//             {
//               id: 11,
//               material_number: "MAT-1011",
//               material_description: "Dicalcium Phosphate",
//               product_type: "Excipient",
//               sap_production_date: "2025-01-11",
//               vendor_batch_number: "VB-011",
//               purchase_document: "PO-9011",
//               unit_operation: "Blending",
//             },
//             {
//               id: 12,
//               material_number: "MAT-1012",
//               material_description: "Talc Powder",
//               product_type: "Excipient",
//               sap_production_date: "2025-01-12",
//               vendor_batch_number: "VB-012",
//               purchase_document: "PO-9012",
//               unit_operation: "Lubrication",
//             },
//             {
//               id: 13,
//               material_number: "MAT-1013",
//               material_description: "Ciprofloxacin",
//               product_type: "API",
//               sap_production_date: "2025-01-13",
//               vendor_batch_number: "VB-013",
//               purchase_document: "PO-9013",
//               unit_operation: "Granulation",
//             },
//             {
//               id: 14,
//               material_number: "MAT-1014",
//               material_description: "HPMC",
//               product_type: "Excipient",
//               sap_production_date: "2025-01-14",
//               vendor_batch_number: "VB-014",
//               purchase_document: "PO-9014",
//               unit_operation: "Coating",
//             },
//             {
//               id: 15,
//               material_number: "MAT-1015",
//               material_description: "Povidone K30",
//               product_type: "Binder",
//               sap_production_date: "2025-01-15",
//               vendor_batch_number: "VB-015",
//               purchase_document: "PO-9015",
//               unit_operation: "Binding",
//             },
//           ],
//           header_data: [
//             { label: "Produced Product", value: "Epidiolex DP" },
//             { label: "Site", value: "KSP" },
//           ],
//         },
//       },
//     });
//   }
// };

export const fetchFilteredBatchList = (payload) => async (dispatch) => {
  dispatch({
    type: FETCH_FILTERED_BATCH_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await genealogyService.fetchFilteredBatchList(payload);
    dispatch({
      type: FETCH_FILTERED_BATCH_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: response, // assumes response has `data`
      },
    });
    return response;
  } catch (error) {
    dispatch({
      type: FETCH_FILTERED_BATCH_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const saveGenealogyReport = (payload) => async (dispatch) => {
  dispatch({
    type: SAVE_REPORT_DATA,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await genealogyService.saveGenealogyReport(payload);
    dispatch({
      type: SAVE_REPORT_DATA,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: SAVE_REPORT_DATA,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchGenealogyReportById = (id) => async (dispatch) => {
  dispatch({
    type: FETCH_GENEALOGY_REPORT_BY_ID,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await genealogyService.fetchGenealogyReportById(id);
    dispatch({
      type: FETCH_GENEALOGY_REPORT_BY_ID,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: response.data, // assumes response has `data`
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_GENEALOGY_REPORT_BY_ID,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};
